import React, { useState, useEffect, useRef } from 'react';
import { locationUtils } from '../../utils/locationUtils';

const countries = [
    { code: 'GLOBAL', name: 'Global', flag: '🌍', currency: 'USD' },
    { code: 'IN', name: 'India', flag: '🇮🇳', currency: 'INR' }
];

const CountrySelector = () => {
    const [currentCountry, setCurrentCountry] = useState(countries[0]);
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        loadCurrentCountry();
        // Close dropdown on scroll
        const handleScroll = () => setIsOpen(false);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const loadCurrentCountry = async () => {
        try {
            const countryData = await locationUtils.detectUserCountry();
            if (countryData.countryCode === 'IN') {
                setCurrentCountry(countries[1]);
            } else {
                setCurrentCountry(countries[0]);
            }
        } catch (error) {
            setCurrentCountry(countries[0]); // Default to Global
        } finally {
            setIsLoading(false);
        }
    };

    const handleCountryChange = async (countryCode) => {
        setIsLoading(true);
        try {
            locationUtils.clearCachedCountry();
            const selectedCountry = countries.find(c => c.code === countryCode);
            const countryData = {
                countryCode: countryCode,
                countryName: selectedCountry.name,
                currency: selectedCountry.currency,
                success: true
            };
            locationUtils.cacheCountry(countryData);
            setCurrentCountry(selectedCountry);
            window.location.reload();
        } catch (error) {
            // fallback
        } finally {
            setIsLoading(false);
            setIsOpen(false);
        }
    };

    if (isLoading) {
        return (
            <div className="country-selector">
                <div className="country-display">
                    <span className="country-flag">🌍</span>
                    <span className="country-text">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="country-selector" ref={dropdownRef}>
            <div 
                className="country-display"
                onClick={() => setIsOpen(!isOpen)}
                style={{ cursor: 'pointer' }}
            >
                <span className="country-flag">{currentCountry.flag}</span>
                <span className="country-text">{currentCountry.name}</span>
                <span className="dropdown-arrow">▼</span>
            </div>
            {isOpen && (
                <div className="country-dropdown">
                    {countries.map((country) => (
                        <div
                            key={country.code}
                            className={`country-option ${currentCountry.code === country.code ? 'selected' : ''}`}
                            onClick={() => handleCountryChange(country.code)}
                        >
                            <span className="country-flag">{country.flag}</span>
                            <span className="country-name">{country.name}</span>
                            <span className="country-currency">({country.currency})</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CountrySelector; 